import React from "react"
import { Link } from "gatsby"
import { FaFacebook } from "react-icons/fa"

export default () => {
  return (
    <footer className="footer">
      <div className="footer__top">
        <a
          href="https://www.facebook.com/Alberta-Bound-Plumbing-Heating-Gasfitting-Ltd-536714256483716/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__facebook"
        >
          <FaFacebook />
        </a>
        <div className="footer__address">
          {/* <div style={{ marginBottom: 15 }}>
            1234 Main Street
            <br />
            Cochrane, Alberta
            <br /> T4C 1G3
          </div>{" "} */}
          <div className="footer__phoneNumber" style={{ marginBottom: 4 }}>
            <span className="footer__phoneNumberCity">Cochrane:</span>
            <span className="settings__touchOnly">
              <br />
            </span>
            <span className="settings__lgOnly">&nbsp;</span>
            <a href="tel:+14037015557" className="footer__phoneLink">
              (403) 701-5557
            </a>
          </div>
          <div>
            <span className="footer__phoneNumberCity">Calgary:</span>
            <span className="settings__touchOnly">
              <br />
            </span>
            <span className="settings__lgOnly">&nbsp;</span>
            <a href="tel:+14037015557" className="footer__phoneLink">
              (403) 992-7805
            </a>
          </div>
        </div>
        <div className="footer__linksContainer">
          <Link to="/">Home</Link>
          <Link to="/plumbing">Plumbing</Link>
          <Link to="/heating">Heating</Link>
          <Link to="/gasfitting">Gasfitting</Link>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__copyrightInfo">
          © {new Date().getFullYear()}, Alberta Bound Plumbing, Heating &
          Gasfitting Ltd.
          <br />
          All Rights Reserved
        </div>
        <a
          href="https://albertabound.sanity.studio"
          className="footer__CMS settings__link"
          target="__blank"
          rel="noopener noreferrer"
        >
          Login
        </a>
      </div>
    </footer>
  )
}
